import styled from "styled-components";
import { device } from "../../stylesheet/breakpoints";

type ArticleProps = {
  addition_position_display: number;
};

export const Article = styled.article<ArticleProps>`
  position: relative;
  width: calc(100% + 20px);
  margin: -10px -10px 0 -10px;

  @media ${device.desktop} {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-width: 210px;
    width: 210px;
    border-radius: 5px;

    ${({ addition_position_display }) =>
      addition_position_display === 1
        ? " margin: -10px 0 -10px -10px;"
        : " margin: -10px -10px -10px 0px;"}
  }
`;

export const ArticleContainer = styled.div`
  position: relative;
  width: 100%;
  //height: 100%;
  padding: 30px 20px 20px 20px;

  &::before {
    content: " ";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: var(--article-bg);
    /* mix-blend-mode: multiply; */

    @media ${device.desktop} {
      border-radius: 5px;
    }
  }

  @media ${device.desktop} {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 20px 36px 20px;
    border-radius: 5px;
  }
`;

export const BoxBonuse = styled.div`
  @media ${device.desktop} {
    width: 100%;
  }
`;
